export const CHALLENGE_CLIP_SOURCES = [
  'match',
  'extract',
  'manual',
  'requested',
  'grammar',
  'quote',
] as const;
